import { createStyles, makeStyles, Theme, createTheme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
    createStyles({
        tableStyle: {
            width: '400px',
            borderStyle: 'none',
        },
        rowStyle: {
            borderStyle: 'none',
        },
        cellStyle: {
            borderStyle: 'none',
        },
        cellName: {
            width: '140px',
        },
        cellData: {
            width: '220px',
        },
        selectNo: {
            width: '120px',
        },
        selectName: {
            width: '200px',
        },
        dropdownStyle: {
            maxHeight: 300,
        },
        gridStyle: {
            borderStyle: 'solid',
            maxWidth: '600px',
        },
        tableHeader: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            backgroundColor: 'grey',
            textAlign: 'center',
            color: 'white',
            padding: '1px',
            minWidth: '80px',
            borderCollapse: `collapse`,
        },
    })
);